import React from 'react'
import Styles from "./FJCloudFulledButton.module.less";
import FJLocalStore from "../../../../store/FJLocalStore";
import InlineSVG from "react-inlinesvg";
import warn from "../../../../icon/warn.svg";
import FJViewConstant from "../../../../constant/FJViewConstant";

function FJCloudFulledButton(props) {
  const {paymentLevel} = props;
  const {onManage, onUpgrade} = props;
  return (
    <div className={Styles.cloud_full}>
      <InlineSVG src={warn} className={Styles.full_icon} />
      <div className={Styles.full_desc}>
        {FJLocalStore._('cloud-storage-is-full')}
        <span onClick={onManage}>{FJLocalStore._('manage')}</span>
        {
          paymentLevel !== FJViewConstant.USER_PAYMENT_BUSINESS ? <>
            or
            <span onClick={onUpgrade}>{FJLocalStore._('upgrade')}</span>
          </> : null
        }
      </div>
    </div>
  );
}

export default FJCloudFulledButton;